class ProgressBar extends HTMLElement{
    constructor(){
        super();
    }

    async connectedCallback(){
        this._targetElement = this.parentElement.nextSibling;
        let tl = gsap.timeline({
            scrollTrigger:{
                trigger:this._targetElement,
                start:'top top',
                end:'bottom bottom',
                scrub:true
            }
        });
        tl.to(this, {opacity: 1, visibility:"visible", duration: '0.05'}, 0)
          .to(this, {width:'100%', ease:'none'}, 0);
    }
}

customElements.define('progress-bar', ProgressBar);